import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';
import { StringConstants } from '@app/shared/string-constants';
import { NotificationService } from '@progress/kendo-angular-notification';

@Component({
	selector: 'kpa-auto-login',
	templateUrl: './auto-login.component.html',
	styleUrl: './auto-login.component.scss',
})
export class AutoLoginComponent implements OnInit {
	isloading: boolean = false;
	loadingAudit = StringConstants.loadingAudit;
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private authService: AuthService,
		private notificationService: NotificationService
	) {}
	ngOnInit(): void {
		const scheduledAuditId = this.route.snapshot.paramMap.get('scheduledAuditId');
		const assigneeId = this.route.snapshot.paramMap.get('assigneeId');
		if (scheduledAuditId && assigneeId) {
			this.isloading = true;
			this.authService.autoLogin(scheduledAuditId, assigneeId).subscribe({
				next: (response) => {
					if (response && response.accessToken) {
						this.router.navigate(['audit']);
					} else {
						this.notificationService.show({
							content: 'Perform Audit request failed. Please try again.',
							hideAfter: StringConstants.hideNotificationAfter,
							position: { horizontal: 'right', vertical: 'bottom' },
							animation: { type: 'fade', duration: 400 },
							type: { style: 'error', icon: true },
						});
						this.router.navigate(['/signin']);
					}
					this.isloading = false;
				},
				error: (err) => {
					this.isloading = false;
					this.notificationService.show({
						content: 'Perform Audit request failed. Please try again.',
						hideAfter: StringConstants.hideNotificationAfter,
						position: { horizontal: 'right', vertical: 'bottom' },
						animation: { type: 'fade', duration: 400 },
						type: { style: 'error', icon: true },
					});
					this.router.navigate(['/signin']);
				},
			});
		} else {
			this.router.navigate(['/signin']);
		}
	}
}
